export default {
  title: 'Order ahead at cafes and restaurants near you | Hey You',
  description:
    'Order ahead and beat the queue. Join 1.2 milion Aussies using Hey You to order their food and drinks ahead of time and never wait in the queue again.',
  pages: {},
  ogImage: 'https://static.heyyou.io/react-unicorn/images/wip.png',
  ogSitename: 'heyyou.com.au',
}
